import React from "react";
import HeaderNew from "../HeaderNew";
import FooterNew from "../FooterNew";
import Footer from "../Footer";
import Loader from "../Loader";
import { Outlet, useLocation } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { isEmpty } from "lodash";
import Calendar from "../Calendar";
import Announcement from "../Announcement";

const LayoutNew = ({ children }) => {
  const location = useLocation();
  const showDate = useContextSelector(AuthContext, (ctx) => ctx.showDate);
  const messagelist = useContextSelector(AuthContext, (ctx) => ctx.messagelist);
  const announcement = useContextSelector(
    AuthContext,
    (ctx) => ctx.announcement,
  );
  const setAnnouncement = useContextSelector(
    AuthContext,
    (ctx) => ctx.setAnnouncement,
  );
  const footerLink = useContextSelector(AuthContext, (ctx) => ctx.footerLink);
  // console.log(location?.pathname, "location?.pathname");
  return (
    <>
      {location?.pathname != "/rewardCenter" &&
      location?.pathname != "/inviteFriends" &&
      location?.pathname != "/myaccount" &&
      location?.pathname != "/receivingCenter" &&
      location?.pathname != "/rescue" &&
      location?.pathname != "/promoCode" &&
      location?.pathname != "/vip" &&
      location?.pathname != "/change-password" &&
      location?.pathname != "/securityCenter" &&
      location?.pathname != "/notice" &&
      location?.pathname != "/m/notice" ? (
        <HeaderNew />
      ) : (
        ""
      )}
      {children}
      <Loader />

      {location?.pathname != "/myaccount" &&
      location?.pathname != "/rewardCenter" &&
      location?.pathname != "/inviteFriends" &&
      location?.pathname != "/receivingCenter" &&
      location?.pathname != "/rescue" &&
      location?.pathname != "/promoCode" &&
      location?.pathname != "/vip" &&
      location?.pathname != "/change-password" &&
      location?.pathname != "/notice" &&
      location?.pathname != "/m/notice" ? (
        <>
          <Footer />
          {location?.pathname != "/casino" && <FooterNew />}
        </>
      ) : (
        ""
      )}
      {showDate?.status && !isEmpty(showDate?.type) && <Calendar />}
      {announcement && <Announcement data={messagelist} />}
    </>
  );
};

export default LayoutNew;
